import { NFTDetailFormatDetector } from '../../nftFormats/NFTFormatDetector/Detail/NFTDetailFormatDetector'
import INFTDetail from './INFTDetail'

export default function NFTDetail({ tokenItem, tokenContract, detailsLoading }: INFTDetail) {
  return NFTDetailFormatDetector({ tokenItem, tokenContract, detailsLoading })
}
